module.exports = __webpack_public_path__ + "static/media/icon_2.5094f1c2.svg";